import React from 'react'

import { dateFormatter } from '@application/Interfaces/Features/Graph/utils'

type AxisTick = {
    x?: number
    y?: number
    payload?: {
        value: string
    }
    color: string
}

export const CustomAxisTick = (props: AxisTick): JSX.Element => {
    const { x = 0, y = 0, payload, color } = props

    return (
        <g transform={`translate(${x},${y})`}>
            <text x={0} y={0} dy={16} textAnchor="end" fill={color} transform="rotate(-25)">
                {dateFormatter(payload?.value as string)}
            </text>
        </g>
    )
}
